<template>
    <v-container class="pa-0">

        <div class="d-sm-block">
            <v-row>
                <v-col class="pb-0 pt-0">
                    <h4>Commute Time</h4>
                </v-col>
            </v-row>
            <v-row class="d-flex flex-column flex-sm-row">
                <v-col>
                    <GMAutoComplete v-on:placeAdded="onGoogleMapsPlaceAdded($event)"
                                    p-holder="Enter property address"
                                    :address="address"
                    />
                </v-col>
                <v-col class="py-0">
                    <v-row class="justify-space-between px-2">
                        <v-col class="px-1">
                            <v-btn
                                    :color="travelMode==='DRIVING' ? 'primary' : ''"
                                    :class="travelMode==='DRIVING' ? '' : 'not-selected'"
                                    @click="travelMode = 'DRIVING'"
                                    height="45"
                                    class="btn-edurent"
                                    depressed
                                    block
                            >
                                Drive
                            </v-btn>
                        </v-col>
                        <v-col class="px-1">
                            <v-btn
                                    :color="travelMode==='WALKING' ? 'primary' : ''"
                                    :class="travelMode==='WALKING' ? '' : 'not-selected'"
                                    @click="travelMode = 'WALKING'"
                                    height="45"
                                    class="btn-edurent"
                                    depressed
                                    block
                            >
                                Walk
                            </v-btn>
                        </v-col>
                        <v-col class="px-1">
                            <v-btn
                                    :color="travelMode==='BICYCLING' ? 'primary' : ''"
                                    :class="travelMode==='BICYCLING' ? '' : 'not-selected'"
                                    @click="travelMode = 'BICYCLING'"
                                    height="45"
                                    class="btn-edurent"
                                    depressed
                                    block
                            >
                                Bike
                        </v-btn>
                        </v-col>
                        <v-col class="px-1">
                            <v-btn
                                    :color="travelMode==='TRANSIT' ? 'primary' : ''"
                                    :class="travelMode==='TRANSIT' ? '' : 'not-selected'"
                                    @click="travelMode = 'TRANSIT'"
                                    height="45"
                                    class="btn-edurent"
                                    depressed
                                    block
                            >
                                Transit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <span v-if="time !== '' && address !==''" class="d-flex pt-0 map-directions"><span class="font-weight-bold mr-1">{{time}}</span> to {{address}}</span>
        </div>

        <div class="mt-6">
            <GoogleMapsDirection :start="origin"
                                 :end="destination"
                                 :travelMode="travelMode"
                                 v-on:renderSuccessful="onRenderSuccessful($event)"
            />
        </div>

    </v-container>
</template>

<script>
    import GMAutoComplete from "./GoogleMaps/GMAutoComplete";
    import GoogleMapsDirection from "./GoogleMaps/GoogleMapsDirection";

    export default {
        name: 'PropertyLocation',
        components: {GoogleMapsDirection, GMAutoComplete},
        props: {
            property: {
                type: Object,
                require: true
            }
        },
        data() {
            return {
                destination: {
                    lng: -71.9969704,
                    lat: 42.551348
                },
                travelMode: '',
                time: '',
                address: ''
            }
        },
        computed: {
            origin() {
                return {
                    lat: Number(this.property.latitude ?? 0),
                    lng: Number(this.property.longitude ?? 0)
                }
            }
        },
        methods: {
            onGoogleMapsPlaceAdded(place) {
                if (this.travelMode === '') {
                    this.travelMode = 'DRIVING'
                }

                this.destination = {
                    lng: place.longitude,
                    lat: place.latitude
                }
            },
            onRenderSuccessful(response) {
                this.time    = response.routes[0].legs[0].duration.text;
                this.address = response.routes[0].legs[0].end_address;
            }
        },
    }
</script>
<style>

    .not-selected {
        border: 1px solid #1976d2;
        color: #1976d2 !important;
        background: transparent !important;
    }

    .map-directions {
        font-size: 14px !important;
    }

</style>
